import { USER_STORE_ID } from '../constants'
import type { AuthUser } from '../entities/AuthUser'

export const useUserStore = () => {
  const state = useState<AuthUser<any>>(USER_STORE_ID, () => ({
    logged: undefined,
    avatar: undefined,
    name: undefined,
    mail: undefined,
    id: undefined,
    type: undefined,
    params: undefined,
  }))

  const getLogged = computed(() => state.value.logged)
  const getUserdata = computed(() => ({
    logged: state.value.logged,
    avatar: state.value.avatar,
    name: state.value.name,
    mail: state.value.mail,
    id: state.value.id,
    type: state.value.type,
    params: state.value.params,
  }))
  const getUserId = computed(() => state.value.id)

  function setUser(user: AuthUser<any>) {
    state.value.logged = user.logged
    state.value.avatar = user.avatar
    state.value.name = user.name
    state.value.mail = user.mail
    state.value.id = user.id
    state.value.type = user.type
    state.value.params = user.params
  }

  return {
    state,
    getLogged,
    getUserdata,
    getUserId,
    setUser,
  }
}
